import businessService from '../services/businessService';

const state = {
  attributes: {},
};

const mutations = {
  setAttribute(state, payload) {
    state.attributes = { ...state.attributes, [payload.key]: payload.value };
  },
  setAttributes(state, attributes) {
    state.attributes = attributes;
  },
};

const actions = {
  async fetchAttributes({ commit, rootGetters }) {
    try {
      const attributes = await businessService.fetchAttributes();
      commit('setAttributes', attributes);
    } catch (e) {
      console.error('error', e);
    }
  },
  setAttribute({ commit }, payload) {
    commit('setAttribute', payload);
  },
};

const getters = {
  attributes: (state) => state.attributes,
  isManagedPartner: (state) => state.attributes?.directory_settings?.is_managed_partner === true,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
